var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Steps',{attrs:{"current":_vm.current - 1}},_vm._l((_vm.steps),function(item){return _c('Step',{key:item.title,attrs:{"title":item.title,"content":item.content}})}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/layoutVue/go-steps.vue